import { render, staticRenderFns } from "./SettlementSettings.vue?vue&type=template&id=34d8a70e"
import script from "./SettlementSettings.vue?vue&type=script&lang=js"
export * from "./SettlementSettings.vue?vue&type=script&lang=js"
import style0 from "./SettlementSettings.vue?vue&type=style&index=0&id=34d8a70e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports